import { MealPlanner } from "@/components/meal-planner"

export default function MealPlanPage() {
  return (
    <div className="py-6">
      <MealPlanner />
    </div>
  )
}
